import React, {useEffect} from 'react'
import {useHistory, withRouter} from "react-router-dom";
import {useCredential} from "../../../components/hooks";
import {ROUTES} from "../../../consts";
import {Alert} from "../../../components/common";
import withRequest from "../../../hoc/withRequest";
import {CredentialFormDumb} from "./CredentialFormDumb";

export const CredentialCreateSmart = () => {

  const history = useHistory();
  const { cleanUpMessage, error, success, postCredential } = useCredential();

  const defaultValues = {
    credentialId: '',
    companyId: '',
    name: '',
    description: '',
    company: '',
    type: 1,
    user: '',
    password: '',
    enabled: '',
    privateKey: '',
    token: '',
    tags: [],
    sudo: '',
    fromEdit: false
  };

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    const body = {
      name: data.name,
      description:data.description,
      company: data.company,
      type: data.type,
      user: data.user,
      password: data.password,
      enabled: data.enabled,
      private_key: data.privateKey,
      token: data.token,
      tags: data.tags,
      sudo: data.sudo
    }
    postCredential({ body })
  }

  useEffect(() => {
    if (!!success.put) history.push(ROUTES.CREDENTIAL_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.put]);

  return (
    <>
      <CredentialFormDumb
          defaultValues={defaultValues}
          handleOnSubmit={handleCreate}
          isEdit={false}
          canEdit={true}
      />
      <Alert
        severity="error"
        handleClose={handleCloseAlert}
        open={error.post}
        message="common.errors.general.title"
      />
    </>
  )
}

export default withRequest(withRouter(CredentialCreateSmart));
